import { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import isEqual from "lodash/isEqual";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { Modal } from "../../../molecules";
import { MODAL_SIZE } from "../modals.constants";
import {
  fetchUserSubscription,
  selectSubscription,
  updateUserSubscription,
} from "../../../../pages/Users";
import { EMPTY_STRING } from "../../../../constants";
import Spinner, { SPINNER_NAMES } from "../../Spinner";
import { selectUser } from "../../../../pages/UserProfile";
const { setSelectedModal } = modalActions;
const { FETCH_USER_SUBSCRIPTION } = SPINNER_NAMES;

const RenderBillingForm = ({ values, handleChange }) => {
  return (
    <div className="form-group">
      <label className="text-sm font-medium text-gray-50 mb-1 block">
        Select Pricing Plan
      </label>
      <Field
        as="select"
        className="form-control"
        name="name"
        value={values.name}
        onChange={handleChange}
      >
        <option value="free">Free</option>
        <option value="paid">Paid</option>
      </Field>
    </div>
  );
};

const ManageBillingModal = () => {
  const dispatch = useDispatch();
  const selectedSubscription = useSelector(selectSubscription);
  const userProfile = useSelector(selectUser);
  const [subscriptionData, setSubscriptionData] = useState({});
  const [currentPlan, setCurrentPlan] = useState({ name: EMPTY_STRING });
  const [subscriptionId, setSubscriptionId] = useState();

  useEffect(() => {
    if (userProfile) {
      const selectedOrganization = JSON.parse(
        sessionStorage.getItem("organization")
      );
      const { subscriptionId: currentSubscriptionId } =
        userProfile.organizations.find(
          (organization) => organization.id === selectedOrganization.id
        );
      setSubscriptionId(currentSubscriptionId);
    }
  }, [userProfile]);

  useEffect(() => {
    if (subscriptionId) dispatch(fetchUserSubscription(subscriptionId));
  }, [dispatch, subscriptionId]);

  useEffect(() => {
    if (selectedSubscription) setSubscriptionData(selectedSubscription);
  }, [selectedSubscription]);

  useEffect(() => {
    if (subscriptionData) setCurrentPlan({ name: subscriptionData.name });
  }, [subscriptionData]);

  const handleClose = useCallback(() => {
    dispatch(setSelectedModal(null));
  }, [dispatch]);

  const handleOnSubmit = useCallback(
    (values) => {
      dispatch(
        updateUserSubscription({ id: subscriptionData.id, data: values })
      );
      dispatch(setSelectedModal());
    },
    [dispatch, subscriptionData]
  );

  const checkIsSubmitButtonDisabled = (subscriptionName, valuesName) =>
    isEqual(subscriptionName, valuesName);

  return (
    <Formik
      enableReinitialize
      initialValues={currentPlan}
      onSubmit={handleOnSubmit}
    >
      {({ values, handleSubmit, handleChange, handleReset }) => {
        const footer = (
          <div className="p-6 space-x-1 border-t border-gray-700 flex align-center justify-end">
            <button
              className="btn btn btn-primary-light"
              type="button"
              onClick={() => {
                handleReset();
                dispatch(setSelectedModal());
              }}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={checkIsSubmitButtonDisabled(
                subscriptionData.name,
                values.name
              )}
              onClick={handleSubmit}
            >
              Update Plan
            </button>
          </div>
        );
        return (
          <Modal
            title={"Manage Subscription"}
            size={MODAL_SIZE.MD}
            handleReset={handleReset}
            handleClose={handleClose}
            footer={footer}
          >
            <Form>
              <div className="modal-body p-6">
                <div className="space-y-4 mb-4">
                  <Spinner name={FETCH_USER_SUBSCRIPTION}>
                    <RenderBillingForm
                      values={values}
                      handleChange={handleChange}
                    />
                  </Spinner>
                </div>
              </div>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default ManageBillingModal;
